import { render } from "./ContratoDetalle.vue?vue&type=template&id=f1c38996&scoped=true"
import script from "./ContratoDetalle.vue?vue&type=script&lang=js"
export * from "./ContratoDetalle.vue?vue&type=script&lang=js"

import "./ContratoDetalle.vue?vue&type=style&index=0&id=f1c38996&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c38996"]])

export default __exports__